import { useState } from 'react';

import { useModifyPrepaidContract } from '../../lib/queries';
import { AppModal } from '../AppModal';
import { todayISO } from './pp-helpers';

import type { PPItem } from './pp-helpers';

export function PPModifyModal({
  item,
  companyId,
  onClose,
}: {
  item: PPItem;
  companyId: string | undefined;
  onClose: () => void;
}) {
  const mut = useModifyPrepaidContract(companyId);
  const [endDate, setEndDate] = useState(item.end);
  const [totalAmount, setTotalAmount] = useState(String(item.total));
  const [effectiveDate, setEffectiveDate] = useState(todayISO);
  const [reason, setReason] = useState('');
  const [err, setErr] = useState<string | null>(null);

  const endChanged = endDate !== item.end;
  const totalChanged = Number(totalAmount) !== item.total;

  function submit() {
    if (!item.apiId) return;
    setErr(null);
    mut.mutate(
      {
        id: item.apiId,
        data: {
          effectiveDate,
          reason,
          ...(endChanged ? { endDate } : {}),
          ...(totalChanged ? { totalAmount: Number(totalAmount) } : {}),
        },
      },
      {
        onSuccess: () => onClose(),
        onError: (e) => setErr(e instanceof Error ? e.message : 'แก้ไขไม่สำเร็จ'),
      },
    );
  }

  return (
    <AppModal
      title={`แก้ไข / กระจายใหม่ — ${item.id}`}
      subtitle="งวดที่ลงบัญชีแล้วคงเดิม; ยอดคงเหลือกระจายใหม่ตามอายุที่เหลือ"
      onClose={onClose}
      footer={
        <>
          <button type="button" className="btn ghost" onClick={onClose}>
            ยกเลิก
          </button>
          <button
            type="button"
            className="btn primary"
            disabled={mut.isPending || !reason.trim() || (!endChanged && !totalChanged)}
            onClick={submit}
          >
            {mut.isPending ? 'กำลังบันทึก…' : 'บันทึกการแก้ไข'}
          </button>
        </>
      }
    >
      <div style={{ display: 'flex', gap: 10, marginBottom: 10 }}>
        <div style={{ flex: 1 }}>
          <label className="meta">มูลค่าสัญญาใหม่</label>
          <input
            className="input"
            type="number"
            value={totalAmount}
            onChange={(e) => setTotalAmount(e.target.value)}
            style={{ width: '100%' }}
          />
        </div>
        <div style={{ flex: 1 }}>
          <label className="meta">วันสิ้นสุดใหม่</label>
          <input
            className="input"
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            style={{ width: '100%' }}
          />
        </div>
      </div>
      {totalChanged && (
        <>
          <label className="meta">วันที่มีผลของ JV ปรับมูลค่า (งวดต้องเปิด)</label>
          <input
            className="input"
            type="date"
            value={effectiveDate}
            onChange={(e) => setEffectiveDate(e.target.value)}
            style={{ width: '100%', marginBottom: 10 }}
          />
        </>
      )}
      <label className="meta">เหตุผล *</label>
      <textarea
        className="input"
        rows={2}
        value={reason}
        placeholder="เช่น ต่ออายุสัญญา / ปรับมูลค่าตามจริง"
        onChange={(e) => setReason(e.target.value)}
        style={{ width: '100%', resize: 'vertical', padding: 8 }}
      />
      {err && <div style={{ color: 'var(--negative)', fontSize: 14, marginTop: 8 }}>{err}</div>}
    </AppModal>
  );
}
